import React from 'react';
import { CLINIC_INFO } from '../utils/constants';

const WhatsAppButton = () => {
    const handleWhatsApp = () => {
        const message = 'Hello! I would like to inquire about dental services.';
        window.open(
            `https://wa.me/${CLINIC_INFO.whatsappNumber}?text=${encodeURIComponent(message)}`,
            '_blank'
        );
    };

    return (
        <button
            className="whatsapp-btn"
            onClick={handleWhatsApp}
            title="Chat with us on WhatsApp"
        >
            💬
        </button>
    );
};

export default WhatsAppButton;